import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getVideosList } from 'api/Video';

export const useVideosList = ({ params, options, dependencies = [] }) => {
  const navigate = useNavigate();
  const { search, page, limit, filters } = params;
  return useQuery(
    ['videos', search, page, limit, filters, ...dependencies],
    () => getVideosList(navigate, params),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      ...options
    }
  );
};
